import React from "react";
import { Button } from "@/components/ui/button";
import { Section, Hint } from "./SettingsShared";
import WalletConnect from "./WalletConnect";

const PayoutTab = ({ user, refreshUser }) => (
  <Section
    title="Payout methods"
    description="Released milestone payments and claimed invoices are paid to your connected wallet."
    data-testid="payout-section"
  >
    <WalletConnect user={user} refreshUser={refreshUser} />

    <div className="pt-5 mt-2 space-y-3 border-t border-border">
      <div className="flex items-center gap-2">
        <span className="font-display font-semibold">Bank / card payout</span>
        <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full bg-secondary text-muted-foreground">
          Coming soon
        </span>
      </div>
      <div className="p-6 text-sm text-center border border-dashed rounded-lg border-border text-muted-foreground" data-testid="payout-coming-soon">
        Bank and card payouts aren't available yet — payments settle to your wallet above.
      </div>
      <Button variant="outline" disabled data-testid="add-payout-btn">
        + Add payout method
      </Button>
      <Hint>We'll enable fiat payouts once off-ramp support lands.</Hint>
    </div>
  </Section>
);

export default PayoutTab;
